module.exports = __webpack_public_path__ + "static/media/stagsleaphero.beaea344.jpg";